import useSWRV from 'swrv';
import globals from '@/globals';
import { resolveURL } from '@/utils/model/fetch_service';

/**
 * @param {*} uri
 * @param {*} params a dictionary of params
 * @returns an absolute URL
 */
export function url(uri, params) {
  // TODO: decouple from the global I dep
  const { I } = globals;
  const prefix = I?.settings?.system?.prefix || '';
  return resolveURL(prefix, uri, params);
}

export const fetcher = async (_url) => {
  const response = await fetch(_url, {
    mode: 'cors',
    credentials: 'include',
  });

  return response.json();
};

export default function useData(key, options) {
  return useSWRV(key, fetcher, options);
}

/**
 * Fetches data from an end-point that follows the { data, error } response convention
 * @param {*} key the absolute URL
 * @returns
 */
export const apiFetcher = async (key) => {
  const response = await fetch(key, {
    mode: 'cors',
    credentials: 'include',
  });
  const json = await response.json();
  if (json && json.error) {
    throw new Error(json.error);
  }
  return json.data;
};

export const Status = Object.freeze({
  IDLE: 'idle',
  LOADING: 'loading',
  RESOLVED: 'resolved',
  ERROR: 'error',
});
